import { ValueSetter as u } from "./Setter.js";
class n {
  run(r, e, s, i) {
    const t = this.parse(r, e, s, i);
    return t ? {
      setter: new u(
        t.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: t.rest
    } : null;
  }
  validate(r, e, s) {
    return !0;
  }
}
export {
  n as Parser
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/parse/_lib/Parser.js
// module id = 23
// module chunks = 41